import { RiCheckboxBlankCircleFill, RiFlag2Fill } from 'react-icons/ri';

const RedFlagIcon = ({
    isFlagged,
}) => {
    if (isFlagged) {
        return (
            <RiFlag2Fill size="16" color="red" />
        );
    }

    return (
        <RiCheckboxBlankCircleFill size="16" color="green" />
    );
};

export default RedFlagIcon;
